<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 mt-6" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable walletTable pb-3"
            :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="desserts" :search="search" :items-per-page="6">
              <template v-slot:item.trxType="{ item }">
                <v-icon small :class="getIcon(item?.trxType)"></v-icon>
                {{ item?.trxType }}
              </template>
              <template v-slot:item.detail="{ item }">
                <router-link class="links text-decoration-none" to="/">
                  <v-icon small>
                    {{ item?.detail }}
                  </v-icon>
                </router-link>
              </template>
              <template v-slot:item.status="{ item }">
                <v-icon small :class="verifyIcon(item?.status)"></v-icon>
                {{ item?.status }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Trx Type",
          align: "start",
          value: "trxType",
        },
        { text: "Date & Time", value: "dataTimes" },
        { text: "Amount", value: "amount" },
        { text: "Acc. No.", value: "accountNumber" },
        { text: "Acc. Type", value: "accountType" },
        { text: "Trx. Fee", value: "trxFee" },

        { text: "Status", value: "status" },
        { text: "Detail", value: "detail" },
      ],
      desserts: [
        {
          trxType: "Depo.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "With.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "With.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Rejected",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "With.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Rejected",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "In",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Pending",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "Out",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "With.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "Depo.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "Depo.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
        {
          trxType: "Depo.",
          dataTimes: "25.08.2020-8:32 pm",
          amount: "$1200",
          accountNumber: "2132 (test)",
          accountType: "Gold",
          trxFee: "$12",
          status: "Approved",
          detail: "mdi-eye-outline",
        },
      ],
      slots: ["7100001492(MICRO)", "7100006392(MICRO)", "7102006392(MICRO)"],
      date: ["2022-01-01", this.getCurrentDate()],
      modal: false,
    };
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split('T')[0];
      return formattedDate;
    },
    getIcon(trxType) {
      if (trxType === "Depo.") return "mdi mdi-tray-arrow-down mr-1 text-gray";
      else if (trxType === "With.") return "mdi mdi-tray-arrow-up mr-1 text-gray";
      else return "mdi mdi-swap-horizontal mr-1 text-gray";
    },
    verifyIcon(status) {
      if (status === "Approved") return "mdi mdi-check text--green mr-1";
      else if (status === "Rejected") return "mdi mdi-window-close text-red mr-1";
      else return "mdi mdi-refresh mr-1 text-warning";
    },
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
};
</script>
